import React from 'react';
import PropTypes from 'prop-types';

import Feature from "Components/Feature";

import PropertyPanel from "Components/PropertyPanel";

import TextArea from 'Components/Properties/Inputs/TextArea';
import Number from 'Components/Properties/Inputs/Number';
import Color from 'Components/Properties/Inputs/Color';
import TextAlign from "Components/Properties/TextAlign";
import TextStyle from "Components/Properties/TextStyle";
import Padding from "Components/Properties/Spacing";

export default class TextPropertiesSidebar extends React.Component
{
    state = {
        data: this.props.element.data
    };

    static propTypes = {
        element: PropTypes.object.isRequired,

        onChanged: PropTypes.func.isRequired,
        onChanging: PropTypes.func.isRequired,

        bringElementForward: PropTypes.func.isRequired,
        sendElementBackward: PropTypes.func.isRequired,
        bringElementToFront: PropTypes.func.isRequired,
        sendElementToBack: PropTypes.func.isRequired,
    };

    static getDerivedStateFromProps(props) {
        return {
            data: props.element.data
        };
    }

    toggleStyle = (style) => {

        const current = this.state.data.styles ? this.state.data.styles : [];

        if (current.includes(style)) {
            current.splice(current.indexOf(style), 1);
        }
        else {
            current.push(style);
        }

        this.handleChangingData('styles', current);

        setTimeout(
            () => this.onBlur()
        );
    };

    handleChangingData = (key, value) => {
        this.props.onChanging(
            this.props.element.id,
            {
                data: {
                    ...this.state.data,
                    [key]: value
                }
            }
        );
    };

    onBlur = () => {
        this.props.onChanged(this.props.element.id);
    };

    render()
    {
        return <>

            <PropertyPanel className='space-y-4' title='Content' defaultOpen>
                <TextArea
                    autoresize
                    className='resize-none'
                    value={this.state.data.text ? this.state.data.text.toString() : ''}
                    onChange={e => this.handleChangingData('text', e.target.value)}
                    onBlur={this.onBlur}
                />
            </PropertyPanel>

            <PropertyPanel className='space-y-4' title='Text' defaultOpen>

                <div className='flex items-center'>
                    <div className='flex-1'>
                        Alignment
                    </div>
                    <TextAlign
                        value={this.state.data.alignment ? this.state.data.alignment.toString() : 'center'}
                        onChange={(alignment) => { this.handleChangingData('alignment', alignment); setTimeout(() => this.onBlur())}}
                    />
                </div>

                <div className='flex items-center'>
                    <div className='flex-1'>
                        Style
                    </div>
                    <TextStyle
                        value={this.state.data.styles ? this.state.data.styles : []}
                        onChange={this.toggleStyle}
                    />
                </div>

                <div className='flex items-center'>
                    <div className='flex-1'>
                        Font size
                    </div>
                    <Number
                        style={{width: 76}}
                        value={this.state.data.fontSize ? this.state.data.fontSize.toString() : '30'}
                        onChange={e => this.handleChangingData('fontSize', e.target.value)}
                        onBlur={this.onBlur}
                        min={1}
                        max={144}
                    />
                </div>

                <div className='flex items-center'>
                    <div className='flex-1'>
                        Colour
                    </div>
                    <Color
                        value={this.state.data.color ? this.state.data.color.toString() : ''}
                        onChange={e => this.handleChangingData('color', e.target.value)}
                        onBlur={this.onBlur}
                    />
                </div>

            </PropertyPanel>

            <PropertyPanel className='space-y-4' title='Spacing'>
                <Padding
                    value={this.state.data.padding ? this.state.data.padding.toString() : '0'}
                    onChange={value => this.handleChangingData('padding', value)}
                    onBlur={this.onBlur}
                />
            </PropertyPanel>

            <Feature when={features => features.textBgColour}>
                <PropertyPanel className='space-y-4' title='Background'>
                    <div className='flex items-center'>
                        <div className='flex-1'>
                            <input
                                type="checkbox"
                                checked={!! this.state.data.backgroundColor}
                                onChange={this.toggleBackgroundColor}
                                className="cursor-pointer focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded m-2 ml-0"
                            />
                            Background color
                        </div>
                        {
                            this.state.data.backgroundColor &&
                            <Color
                                value={this.state.data.backgroundColor ? this.state.data.backgroundColor.toString() : ''}
                                onChange={e => this.handleChangingData('backgroundColor', e.target.value)}
                                onBlur={this.onBlur}
                            />
                        }
                    </div>
                </PropertyPanel>
            </Feature>

        </>;
    }

    toggleBackgroundColor = (e) => {
        const checked = !! this.state.data.backgroundColor;

        this.handleChangingData(
            'backgroundColor',
            checked ? null : '#000000'
        );

        this.onBlur();
    }
}
